<template lang="html">
  <transition name="move">
    <div class="modifymyinfo" ref="modifymyinfo">
        <div class="modifymyinfo-wrapper">
            <div class="modifymyinfo-wrapper-auot">
              <!-- 我的资料 -->
                <span class ="modifymyinfotet">{{ $t('mydescription') }}</span>
                
                <div class="modifyUserdata">
                    <div class="modifyUserdata-str">
                      <!-- description -->
                        <span>{{ $t('description') }}</span>
                    </div>
                    <input  class="modifyUserdata-input"   v-model="modifymyinfoobj.description"/>
                </div>

                <div class="modifyUserdata">
                    <div class="modifyUserdata-str">
                      <!-- 姓名 -->
                        <span>{{ $t('username') }}：</span>
                    </div>
                    <input  class="modifyUserdata-input"   v-model="modifymyinfoobj.id" disabled/>
                </div>
                 <div class="modifyUserdata">
                    <div class="modifyUserdata-str">
                      <!-- 密码 -->
                        <span>{{ $t('password') }}：</span>
                    </div>
                    <input type="password" class="modifyUserdata-input"   v-model="modifymyinfoobj.pw"/>
                </div>
                 <div class="modifyUserdata">
                    <div class="modifyUserdata-str">
                      <!-- 密码 -->
                        <span>{{ $t('password2') }}：</span>
                    </div>
                    <input type="password" class="modifyUserdata-input"   v-model="modifymyinfoobj.pw2"/>
                </div>
                
                <div class="modifyUserdata-msg" @click="modifyUser($event)">
                    <span class="pay">
                        <!-- 完成 -->
                        {{ $t('complete') }}
                    </span>
                </div>
                 
                <div class="modifyUserdata-err">
                  <span>{{ modifymyinfoobj.msg }}</span>
                </div>          
                <div class="modifyUserdata-openId">
                  <span>{{ $store.state.myinfo.openId }}</span>
                </div> 
                <div class="detail-close" @click="loginHide">
                  <i class="icon-close"></i>
                </div>
            </div>
        </div>
    </div>
  </transition>
</template>

<script>
import {Encrypt} from 'common/js/secret.js'
import eventbus from '../../common/js/eventbus.js'

export default {
  props: {
  },
  data() {
    return {
      state: this.$store.state,
      modifymyinfoobj: {
        id: '',
        pw: '',
        pw2: '',
        description: '',
        ismodifymyinfoing: false,
        msg: ''
      }
    }
  },
  updated() {
  },
  created() {
    this.modifymyinfoobj.id = this.$store.state.myinfo.username
    this.modifymyinfoobj.description = this.$store.state.myinfo.description
  },
  methods: {
    loginHide() {
      this.$router.go(-1)
    },
    autoResetMsg(t) {
      let _this = this
      setTimeout(function () {
        _this.modifymyinfoobj.msg = ''
      }, t)
    },
    checkinfomodifyUser() {
      if (this.modifymyinfoobj.ismodifymyinfoing) return false
      // if (this.modifymyinfoobj.id === null || this.modifymyinfoobj.id === '') this.modifymyinfoobj.msg = this.$tc('loginerror', 0) // '请输入用户名'
      // else
      if (this.modifymyinfoobj.description === null || this.modifymyinfoobj.description === '') this.modifymyinfoobj.msg = this.$t('loginerror0') // '昵称...........'
      else if (this.modifymyinfoobj.pw2 !== null && this.modifymyinfoobj.pw2 !== '' && this.modifymyinfoobj.pw !== null && this.modifymyinfoobj.pw !== '' && this.modifymyinfoobj.pw !== this.modifymyinfoobj.pw2) this.modifymyinfoobj.msg = this.$t('loginerror5') // '两次密码不对'
      else this.modifymyinfoobj.msg = ''
      this.autoResetMsg(1500)
      if (this.$store.state.dev) console.log('--检查资料完整---', this.modifymyinfoobj.msg)
      if (this.modifymyinfoobj.msg !== null && this.modifymyinfoobj.msg !== '') { return false } else { return true }
    },
    modifyUser(e) {
      if (this.state.myinfo !== null && this.state.myinfo.openId !== 'undefined' && this.state.myinfo.openId !== '') {
        if (this.$store.state.dev) console.log('1.修改资料点击,页面变量:', this.modifymyinfoobj.description)
        if (this.checkinfomodifyUser() === false) return
        this.modifymyinfoobj.ismodifymyinfoing = true

     // 修改资料
        if (this.$store.state.dev) console.log('2.修改资料,公共变量', this.state.myinfo.description)

        var newhash = (this.modifymyinfoobj.id !== null && this.modifymyinfoobj.id !== '') ? '&newhash=' + encodeURIComponent(this.modifymyinfoobj.pw2) : ''
        var pic = '&pic=' + encodeURIComponent(this.$store.state.myinfo.avatar)
        this.$http.get(this.api.modifyUserInfo + '?openId=' + encodeURIComponent(Encrypt(this.state.myinfo.openId || '')) + '&hash=' + encodeURIComponent(this.state.myinfo.hash || '') + '&description=' + encodeURIComponent(this.modifymyinfoobj.description || '') + newhash + pic + '&SellerID=' + (this.state.myinfo.SellerID || 1) + this.state.ibnumber)
              .then(res => {
                if (res.data.code === 0) {
                  if (this.$store.state.dev) console.log('3.修改资料,api返回', res.data.message)
                  this.state.myinfo = res.data.data
                  if (this.$store.state.dev) console.log('4.修改资料后,公共变量', this.state.myinfo.description)
                  this.$store.dispatch('saveinfo', this.state)
                  if (this.$store.state.dev) console.log('5.修改资料后,异步保存到本地持久化,eventbus refresh_myinfo')
                  eventbus.$emit('refresh_myinfo', this.state.myinfo)
                  if (this.$store.state.dev) console.log('6.修改资料后,路由到[我的]选项卡,公共变量', this.state.myinfo.description)
                  this.$router.push('/mymessage')
                } else {
                  if (res.data.code === 99) {
                    this.modifymyinfoobj.msg = this.$t('loginerror7')
                  } else {
                    this.modifymyinfoobj.msg = res.data.message
                  }
                  this.ismodifymyinfoing = false
                  console.error('3.修改资料', this.tip2, res.data.message)
                  return
                }
              })
            .catch(err => {
              this.modifymyinfoobj.msg = this.$t('loginerror7') // 修改资料失败       6 用户名已存在
              this.modifymyinfoobj.ismodifymyinfoing = false
              console.error('保存地址', err)
              this.autoResetMsg(3500)
              return
            })

        this.modifymyinfoobj.ismodifymyinfoing = false
      }
    }
  },
  components: {
  }
}
</script>

<style lang="scss">
@import '../../common/sass/mixin.scss';

.modifymyinfo {
    position: fixed;
    left: 0;
    top: 0;
    bottom: 0;
    z-index: 10;
    width: 100%;
    background: rgba(7, 17, 27, 0.5);
    &.move-enter-active,
    &.move-leave-active {
        // 动画过程
        transition: all 0.5s;
        transform: translate3d(0, 0, 0);
    }
    &.move-enter,
    &.move-leave-to {
        // 动画初始态
        transform: translate3d(100%, 0, 0);
    }

    .modifymyinfo-wrapper {
        border-radius: 10px;
        position: absolute;
        /* right: auto; */
        bottom: 10%;
        top: 10%;
        left: 10%;
        width: 80%;
        height: 500px;
        margin: auto;
        background-color: #fff;
        .modifymyinfo-wrapper-auot {
            width: 80%;
            margin: auto;
            height: 100px;
            .modifymyinfotet {
                display: block;
                font-size: 30px;
                color: #4b2354;
                line-height: 1.2;
                text-align: center;
                padding: 20px 0px;
                @include border-1px(rgba(7, 17, 27, 0.1));
            }

            .modifyUserdata {
                position: relative;
                padding: 12px 0;
                box-sizing: border-box;
                @include border-1px(rgba(7, 17, 27, 0.1));
                .modifyUserdata-input {
                    display: flex;
                    padding: 2%;
                    width: 96%;
                    line-height: 24px;
                    background: #f7f7f7;
                    border: 1px solid #ced4da;
                    border-radius: 0.25rem;
                }
                .modifyUserdata-str {
                    display: flex;
                    width: 100%;
                    line-height: 24px;
                    color: #000;
                }
            }

            .modifyUserdata-err {
                width: 100%;
                position: relative;
                top: 25px;
                text-align: center;
                color: red;
            }

            .modifyUserdata-openId { 
                position: relative;
                font-size: 6px;
                top: 25px;
                text-align: center;
                color: #dbc2c2d2;
            }
            
            .modifyUserdata-modifyUser {
                width: 100%;
                position: relative;
                top: 15px;
                .checkbtn {
                    height: 16px;
                    width: 16px;
                    color: rgb(0, 180, 60);
                }
                .label-modifyUser {
                    width: 100%;
                    position: relative;
                    left: 5px;
                }
            }
            .modifyUserdata-msg {
                background: #00b43c;
                border-radius: 10px;
                position: relative;
                width: 100%;
                overflow: hidden;
                height: 40px;
                top: 10px;
                text-align: center;
                .pay {
                    line-height: 40px;
                    text-align: center;
                    font-size: 14px;
                    font-weight: 700;
                    color: #fff;
                    &.not-enough {
                        background: #2b333b;
                    }
                    &.enough {
                        background: #00b43c;
                        color: #fff;
                    }
                }
            }
            .detail-close {
                // background: green;
                width: 32px;
                height: 32px;
                // margin-top: -64px auto 0 auto;
                font-size: 32px;
                line-height: 32px;
                clear: both;
                top: 10px;
                right: 10px;
                position: absolute;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// modifymyinfo.vue?3e312555